export default {
  dataPartner: state => field => state[field]
};
